import { message as messageAntd } from 'antd';
import type { MessageType } from 'antd/es/message';
import { useCallback, useEffect, useState } from 'react';

export const copyToClipboard = (text: string, message?: MessageType): void => {
  navigator.clipboard.writeText(text).then(
    () => {
      if (message) {
        return message;
      }

      messageAntd.success('Text copied to clipboard.');
    },
    () => {
      messageAntd.error('Failed to copy text to clipboard.');
    }
  );
};

export const useCopyToClipboard = (timeout = 3000) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboardWithAlert = useCallback(
    async (e: React.MouseEvent<HTMLElement>, text: string) => {
      e.stopPropagation();

      try {
        await navigator.clipboard.writeText(text);
        setCopied(true);
      } catch {
        console.error('Failed to copy text to clipboard.');
      }
    },
    []
  );

  useEffect(() => {
    if (!copied) {
      return;
    }

    const timer = setTimeout(() => {
      setCopied(false);
    }, timeout);

    return () => clearTimeout(timer);
  }, [copied, timeout]);

  return {
    copied,
    copyToClipboardWithAlert,
  };
};
